"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalDialogContent = exports.ModalClose = void 0;
var _react = _interopRequireDefault(require("react"));
var _Clickable = require("../Clickable");
var _Box = require("../Box");
var _Flex = require("../Flex");
var _Text = require("../Text");
var _CloseIcon = _interopRequireDefault(require("@artsy/icons/CloseIcon"));
var _ArtsyLogoIcon = _interopRequireDefault(require("@artsy/icons/ArtsyLogoIcon"));
var _useSentinelVisibility = require("../../utils/useSentinelVisibility");
var _Spacer = require("../Spacer");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _themeGet = require("@styled-system/theme-get");
var _Theme = require("../../Theme");
var _excluded = ["children", "footer", "hasLogo", "leftPanel", "onClose", "rightPanel", "title", "header"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var ModalDialogContent = function ModalDialogContent(_ref) {
  var children = _ref.children,
    footer = _ref.footer,
    hasLogo = _ref.hasLogo,
    leftPanel = _ref.leftPanel,
    onClose = _ref.onClose,
    rightPanel = _ref.rightPanel,
    title = _ref.title,
    header = _ref.header,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useSentinelVisibilit = (0, _useSentinelVisibility.useSentinelVisibility)(),
    topSentinel = _useSentinelVisibilit.sentinel,
    isAtTop = _useSentinelVisibilit.isSentinelVisible;
  var _useSentinelVisibilit2 = (0, _useSentinelVisibility.useSentinelVisibility)(),
    bottomSentinel = _useSentinelVisibilit2.sentinel,
    isAtBottom = _useSentinelVisibilit2.isSentinelVisible;
  var _useTheme = (0, _Theme.useTheme)(),
    theme = _useTheme.theme;
  return /*#__PURE__*/_react.default.createElement(_Flex.Flex, _extends({
    bg: "white100",
    m: 2,
    style: {
      boxShadow: theme.effects.dropShadow
    }
  }, rest), leftPanel, /*#__PURE__*/_react.default.createElement(_Flex.Flex, {
    flexDirection: "column",
    overflow: "hidden",
    width: "100%"
  }, /*#__PURE__*/_react.default.createElement(_Flex.Flex, {
    flexDirection: "column",
    zIndex: 1,
    style: {
      transition: "box-shadow 250ms",
      boxShadow: isAtTop ? theme.effects.dropShadow : undefined
    }
  }, /*#__PURE__*/_react.default.createElement(_Flex.Flex, {
    alignItems: "flex-start",
    justifyContent: "space-between"
  }, (title || hasLogo) && /*#__PURE__*/_react.default.createElement(_Box.Box, {
    m: 2
  }, hasLogo && /*#__PURE__*/_react.default.createElement(_ArtsyLogoIcon.default, {
    display: "block",
    width: 75,
    height: 26
  }), hasLogo && title && /*#__PURE__*/_react.default.createElement(_Spacer.Spacer, {
    y: 2
  }), title && /*#__PURE__*/_react.default.createElement(_Text.Text, {
    variant: "lg-display",
    lineClamp: 6,
    hyphenate: true
  }, title)), /*#__PURE__*/_react.default.createElement(ModalClose, {
    onClick: onClose
  })), header && /*#__PURE__*/_react.default.createElement(_Box.Box, {
    px: 2,
    pb: 2
  }, header)), /*#__PURE__*/_react.default.createElement(_Box.Box, {
    px: 2,
    pb: 2,
    flex: 1,
    overflow: "auto",
    style: {
      WebkitOverflowScrolling: "touch"
    }
  }, topSentinel, children, bottomSentinel), footer && /*#__PURE__*/_react.default.createElement(_Box.Box, {
    p: 2,
    style: {
      transition: "box-shadow 250ms",
      boxShadow: isAtBottom ? theme.effects.dropShadow : undefined
    }
  }, footer)), rightPanel);
};
exports.ModalDialogContent = ModalDialogContent;
ModalDialogContent.displayName = "ModalDialogContent";
var ModalClose = function ModalClose(props) {
  return /*#__PURE__*/_react.default.createElement(Close, _extends({
    p: 2,
    ml: "auto",
    "aria-label": "Close"
  }, props), /*#__PURE__*/_react.default.createElement(_CloseIcon.default, {
    fill: "currentColor",
    display: "block"
  }));
};
exports.ModalClose = ModalClose;
ModalClose.displayName = "ModalClose";
var Close = (0, _styledComponents.default)(_Clickable.Clickable).withConfig({
  displayName: "ModalDialogContent__Close",
  componentId: "ow6myz-0"
})(["color:", ";&:focus,&.focus-visible{outline:none;color:", ";}"], (0, _themeGet.themeGet)("colors.black100"), (0, _themeGet.themeGet)("colors.black60"));
//# sourceMappingURL=ModalDialogContent.js.map